import { render, staticRenderFns } from "./TravelNoteDetailBanner.vue?vue&type=template&id=00e826e0&scoped=true"
import script from "./TravelNoteDetailBanner.vue?vue&type=script&lang=js"
export * from "./TravelNoteDetailBanner.vue?vue&type=script&lang=js"
import style0 from "./TravelNoteDetailBanner.vue?vue&type=style&index=0&id=00e826e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e826e0",
  null
  
)

export default component.exports